import React, { useState } from 'react';

import { App, Button, Popconfirm } from 'antd';

import { CloseCircleOutlined } from '@ant-design/icons';
import { LoadedGuestLog, useGuestsLogs } from 'lib/providers/GuestsLogsContextProvider';
import { smoothLoading } from 'lib/smoothLoading';
import { cancelGuestLog } from 'services/Guest.service';

type Props = { guestLog: LoadedGuestLog };

export function GuestsLogsActionsCell({ guestLog }: Props) {
    const [IsCancelPopupVisible, setIsCancelPopupVisible] = useState(false);
    const [isCancelling, setIsCancelling] = useState(false);

    const app = App.useApp();

    const { fetchGuestsLogs } = useGuestsLogs();

    const handleCancel = async () => {
        setIsCancelling(true);

        const response = await cancelGuestLog(guestLog.id);

        await smoothLoading();

        setIsCancelling(false);

        if (response.type === 'error')
            return app.notification.error({ message: response.message, description: response.description });

        app.notification.open(response);

        setIsCancelPopupVisible(false);

        fetchGuestsLogs();
    };

    if (guestLog.canceled_at !== null)
        return null;

    return (
        <Popconfirm
            title="Cancelar registro"
            description="Tem certeza que deseja cancelar?"
            open={IsCancelPopupVisible}
            placement="left"
            cancelText="Não"
            okText="Sim"
            okType="danger"
            okButtonProps={{ loading: isCancelling }}
            onConfirm={handleCancel}
            onCancel={() => setIsCancelPopupVisible(false)}
        >
            <Button
                type="text"
                icon={<CloseCircleOutlined />}
                title="Cancelar"
                onClick={() => setIsCancelPopupVisible(true)}
            />
        </Popconfirm>
    );
}
